import { useDispatch, useSelector } from "react-redux";
import { gradeOptionsTools } from "../../../constants";
import OptionsDropDown from "../../UI/options_drop_down/options_drop_down";
import classes from "../criteriaSubmission.module.css";


const Grade = ({ isLoading, selectStoreData, setStoreData }) => {
  const storeData = useSelector(selectStoreData);
  const dispatch = useDispatch();

  const { grade } = storeData || {};

  const handleGradeSelection = (event) => {
    const { value } = event.target;
    // Only send the changed field, not the whole storeData
    dispatch(setStoreData({ grade: value }));
    localStorage.setItem("grade", value);
  };

  return (

    <div className={classes["input-container"]}>
  <label className={classes.formLabel} htmlFor="grade">Select a grade:</label>
      <OptionsDropDown
        options={gradeOptionsTools}
        name="grade"
        onChangeHandler={handleGradeSelection}
        isDisabled={isLoading}
        value={grade || ""}
      />
    </div>
  );
};

export default Grade;
